import React, {Component} from 'react';
import Lang from '../../../i18n'
import { withRouter } from 'react-router-dom'
var classNames = require('classnames');

class TotalsView extends Component {

  returnData = (data) =>{
    const styles = this.props.styles;
    const totalsData = data.map( (item) => {
      const sum = Number(item.sum).toLocaleString('de-DE');
      if (item.sum > 0) {
        return(
          <li key={item.month}>
            <span>{item.month}</span> <span className={styles.positive}>{sum}</span>
          </li>
        );
      }
      else {
        return(
          <li key={item.month}>
            <span>{item.month}</span> <span className={styles.negative}>{sum}</span>
          </li>
        );
      }
    });
    return totalsData
  }
  render() {
    const styles = this.props.styles;
    const data = this.props.data;
    var leftData = []
    var rightData = []
    const isHighlightedBoxStyles = this.props.highlightBox ? styles.highlight : null;
    for (let index = 0; index < data.length; index++) {
      if(index < 12){
        leftData.push({
          month: data[index].month,
          sum: data[index].sum
        })
      }
      else{
        rightData.push({
          month: data[index].month,
          sum: data[index].sum
        })
      }
    }
    return (
      <div className={styles.fullTotals}>
        <div className={classNames(styles.totalsData, isHighlightedBoxStyles)}>
          <ul>
            <li><span>{Lang.translate('calculator:month', this.props.location.pathname)}</span>
            <span>{Lang.translate('calculator:earnings', this.props.location.pathname)}</span></li>
            {this.returnData(leftData)}
          </ul>
        </div>
        <div className={classNames(styles.totalsData, isHighlightedBoxStyles)}>
          <ul>
            <li><span>{Lang.translate('calculator:month', this.props.location.pathname)}</span>
            <span>{Lang.translate('calculator:earnings', this.props.location.pathname)}</span></li>
            {this.returnData(rightData)}
          </ul>
        </div>
      </div>

    );
  }
}

export default withRouter(TotalsView);



// WEBPACK FOOTER //
// ./src/components/calculator/totals/c_totals.js